import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient} from "@angular/common/http";
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AlertService} from "../../services/alert.service";
import {AuthService} from "../../services/auth.service";
import {SiteSelectComponent} from "../../domain/site/site-select.component";
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-ticket-detail',
  templateUrl: './ticket-detail.component.html'
})
export class TicketDetailComponent implements OnInit {
  @ViewChild("siteSite", {static: false}) siteSite: SiteSelectComponent;
  @ViewChild("siteSiteId", {static: false}) siteSiteIdSel: SiteSelectComponent;

  @Input()
  ticketNumber: any;

  @Input()
  ticketId: any;

  ticket: any;
  filterNetId: any;
  refreshWorklog: boolean = false;
  // siteSiteIdDummy: any;
  get isNewTicket(): boolean {
    return !this.ticket.id && !this.ticket.ticketNumber;
  }

  constructor(private env: EnvService,
              private http: HttpClient,
              private route: ActivatedRoute,
              private router: Router,
              public authService: AuthService,
              private lookupService: LookupService,
              private alertService: AlertService) {
  }

  public ngOnInit(): void {
    if (this.ticketId || this.ticketNumber) {
      this.loadId(this.ticketId, this.ticketNumber);
    } else {
      this.route.params
        .subscribe((params: Params) => {
          let id: any = params['id'];
          let ticketNumber: any = params['ticketNumber'];
          if ((!id || id === '0') && !ticketNumber) {
            this.createNew();
          } else {
            this.loadId(id, ticketNumber);
          }
        });
    }

  }

  loadId(id, ticketNumber) {
    if (id) {
      this.http.get(`${this.env.e.url}/task/tickets/${id}`).subscribe(
        data => {
          this.setTicket(data);
        }
      );
    } else if (ticketNumber) {
      this.http.get(`${this.env.e.url}/task/tickets/ticketNumber/${ticketNumber}`).subscribe(
        data => {
          this.setTicket(data);
        }
      );

    }
  }

  setTicket(ticket: any) {
    this.ticket = ticket;
    this.ticket.acceptTimeEpoch = ticket.acceptTime ? new Date(this.ticket.acceptTime).getTime() : undefined;
    this.ticket.assignTimeEpoch = ticket.assignTime ? new Date(this.ticket.assignTime).getTime() : undefined;
    this.ticket.clearedTimeEpoch = ticket.clearedTime ? new Date(this.ticket.clearedTime).getTime() : undefined;
    this.ticket.dateTimeClearedEpoch = ticket.dateTimeCleared ? new Date(this.ticket.dateTimeCleared).getTime() : undefined;
    this.ticket.endTimeEpoch = ticket.endTime ? new Date(this.ticket.endTime).getTime() : undefined;
    this.ticket.logDateTimeEpoch = ticket.logDateTime ? new Date(this.ticket.logDateTime).getTime() : undefined;
    this.ticket.nextUpdateTimeEpoch = ticket.nextUpdateTime ? new Date(this.ticket.nextUpdateTime).getTime() : undefined;
    this.ticket.reportedTimeEpoch = ticket.reportedTime ? new Date(this.ticket.reportedTime).getTime() : undefined;
    this.ticket.startTimeEpoch = ticket.startTime ? new Date(this.ticket.startTime).getTime() : undefined;
    this.ticket.updatedDateTimeEpoch = ticket.updatedDateTime ? new Date(this.ticket.updatedDateTime).getTime() : undefined;
    this.ticket.worklogFeedback = "";
  }

  createNew() {
    this.ticket = {
      id: undefined,
      ticketNumber: undefined,
      status: 0,
      affectedResourceType: 'SITE',
      loggedByUserId: this.authService.getUser().id,
      faultDescription: "",
      startTime: new Date(),
      worklogFeedback: ""
    };
  }

  save(newStatus:any = undefined) {

    let preStatus = {
      status: this.ticket.status,
      closedBy: this.ticket.closedBy,
      endTimeEpoch: this.ticket.endTimeEpoch,
    };
    if (newStatus) {
      this.ticket.status = newStatus.status;
      this.ticket.closedBy = newStatus.closedBy;
      this.ticket.endTimeEpoch = newStatus.endTimeEpoch;
    }

    this.ticket.acceptTime = this.ticket.acceptTimeEpoch ? new Date(this.ticket.acceptTimeEpoch) : undefined;
    this.ticket.assignTime = this.ticket.assignTimeEpoch ? new Date(this.ticket.assignTimeEpoch) : undefined;
    this.ticket.clearedTime = this.ticket.clearedTimeEpoch ? new Date(this.ticket.clearedTimeEpoch) : undefined;
    this.ticket.dateTimeCleared = this.ticket.dateTimeClearedEpoch ? new Date(this.ticket.dateTimeClearedEpoch) : undefined;
    this.ticket.endTime = this.ticket.endTimeEpoch ? new Date(this.ticket.endTimeEpoch) : undefined;
    this.ticket.logDateTime = this.ticket.logDateTimeEpoch ? new Date(this.ticket.logDateTimeEpoch) : undefined;
    this.ticket.nextUpdateTime = this.ticket.nextUpdateTimeEpoch ? new Date(this.ticket.nextUpdateTimeEpoch) : undefined;
    this.ticket.startTime = this.ticket.startTimeEpoch ? new Date(this.ticket.startTimeEpoch) : undefined;
    this.ticket.reportedTime = this.ticket.reportedTimeEpoch ? new Date(this.ticket.reportedTimeEpoch) : undefined;
    this.ticket.updatedDateTime = this.ticket.updatedDateTimeEpoch ? new Date(this.ticket.updatedDateTimeEpoch) : undefined;

    if (!this.ticket.id) {
      this.http.post(`${this.env.e.url}/task/tickets`, this.ticket)
        .subscribe(
          data => {
            this.setTicket(data);
            this.refreshWorklog = !this.refreshWorklog;
            this.alertService.info(`Created NMC/${this.ticket.ticketNumber}`);
          }
        );
    } else {

      this.http.put(`${this.env.e.url}/task/tickets/${this.ticket.id}`, this.ticket)
        .subscribe(
          data => {
            this.setTicket(data);
            this.refreshWorklog = !this.refreshWorklog;
            this.alertService.info(`Updated NMC/${this.ticket.ticketNumber}`);
          },
          error => {
            this.ticket.status = preStatus.status;
            this.ticket.closedBy = preStatus.closedBy;
            this.ticket.endTimeEpoch = preStatus.endTimeEpoch;
          }
        );
    }
  }

  delete() {
    this.http.delete(`${this.env.e.url}/task/tickets/${this.ticket.id}`)
      .subscribe(
        complete => {
          this.alertService.info(`Deleted NMC/${this.ticket.ticketNumber}`);
          this.router.navigate(["/tickets"]);
        }
      );
  }

  formatTicketNumber(ticketNumber: number): string {
    return `NOC/${String(ticketNumber).padStart(6, '0')}`;
  }

  protected neChanged(ne: any) {
    if (ne?.netId !== this.filterNetId) {
      this.filterNetId = ne?.netId;
    }

    let site:any = undefined;

    if (ne) {
      if (ne.sites.length == 1 && this.ticket.affectedResourceType === 'SITE') {
        this.ticket.siteId = ne.sites[0];
        site = this.siteSite.findSite(this.ticket.siteId);
      }
    } else if (this.ticket.affectedResourceType === 'NE'){
      this.ticket.siteId = undefined;
    }

    this.ticket.tnumber = site?.siteId;
    this.setupSiteContact(site);
  }

  protected onSiteChanged(site: any) {
    this.ticket.tnumber = site?.siteId;
    this.setupSiteContact(site);
  }

  protected onSiteIdSiteChange(site: any) {
    this.ticket.tnumber = site?.siteId;
    this.setupSiteContact(site);
  }

  protected getSiteSiteId(option: any) {
    if (!option) return "undefined";
    return option.siteId;
  }
  protected getSiteSiteName(option: any) {
    if (!option) return "undefined";
    return `${option.name} (${option.siteId})`;
  }

  protected formatStatus(ticket: any) {
    if (ticket.status === 0) return "OPEN";
    else return "CLOSED";
  }

  protected toggleTicketStatus() {
    if (this.ticket.status === 0) {
      let status = {
        status: 1,
        closedBy: this.authService.getUser().username,
        endTimeEpoch: new Date().getTime(),
      }
      this.save(status);
    } else {
      let status = {
        status: 0,
        closedBy: undefined,
        endTimeEpoch: undefined,
      }
      this.save(status);
    }
  }

  protected onServiceProviderChange(company: any) {
    this.ticket.serviceProvider = company?.name;
    this.ticket.departmentId = undefined;
    this.ticket.departmentRegion = undefined;
    this.ticket.assignedToUserId = undefined;
    this.ticket.assignedTo = undefined;
  }
  protected onDepartmentChange(department: any) {
    this.ticket.departmentRegion = department?.name;
    this.ticket.assignedToUserId = undefined;
    this.ticket.assignedTo = undefined;
  }
  protected onAssignedToChange(contact: any) {
    this.ticket.assignedTo = contact?.name;
  }

  private setupSiteContact(site: any, override: boolean = false) {
    let contactId = site?.firstContactId;
    contactId = contactId ? contactId : site?.secondContactId;
    contactId = contactId ? contactId : site?.supervisorContactId;
    if (contactId) {
      this.http.get(`${this.env.e.url}/auth/contacts/${contactId}`).subscribe(
        data => {
          let contact:any = data;
          if (override || this.isNewTicket || (!this.ticket.serviceProviderId || !this.ticket.departmentId || !this.ticket.assignedToUserId)) {
            this.ticket.serviceProviderId = contact?.contactCompanyId;
            this.ticket.serviceProvider = this.lookupService.lookup("auth", "contactCompanies", contact.contactCompanyId, undefined)
            this.ticket.departmentId = contact?.contactDepartmentId;
            this.ticket.departmentRegion = this.lookupService.lookup("auth", "contactDepartments", contact.contactDepartmentId, undefined)
            this.ticket.assignedToUserId = contact?.id;
            this.ticket.assignedTo = contact?.name;
          }
        }
      );
    }
  }

  protected syncSiteContact() {
    if (this.ticket.siteId) {
      let site = this.siteSite.findSite(this.ticket.siteId);
      this.setupSiteContact(site, true);
    }
  }
}
